import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CreateTeamFabComponent } from '../create-team-fab/create-team-fab.component';
import { CreateTeamComponent } from './create-team.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { ItaTeamGetterComponent } from './ita-team-getter/ita-team-getter.component';
import { UploadImageModule } from '../../_shared/components/upload-image/upload-image.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    UploadImageModule,
  ],
  declarations: [
    CreateTeamFabComponent,
    CreateTeamComponent,
    ColorPickerComponent,
    ItaTeamGetterComponent,
  ],
  exports: [CreateTeamFabComponent],
})
export class CreateTeamModule {}
